<!-- 带搜索，下滑加载更多的下拉框。目前是用于公众号下拉框和投放作品下拉框 -->
<template>
<div>
	<a-select
		:mode="select_mode" 
		:class="[ page_type == 'effectB'? 'page-true':'page-false', ]"
		:placeholder="placeholder"
		:filter-option="false"
		@change="handleChangeGzh"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScrollGzh" 
		showSearch
		allowClear
		@search="selectGzhSearch"
		:not-found-content="gzh_fetching ? undefined : null" 
		@blur="gzhBlur"
		:value="r_gzh_id"
	  >
		<a-spin v-if="gzh_fetching" slot="notFoundContent" size="small" />
		<a-select-option v-for="(item,index) in showFilterData" :key="index" :value="item.key" :title="item.value">
		  {{item.value}}
		</a-select-option>
		<a-select-option v-if="loading_gzh_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
</div>
</template>

<script>
export default {
    name: 'selectCompont',
    props: ['placeholder','select_mode','page_type'],
	watch: { // 父组件传过来的值不支持直接修改，所以这里用新的变量接收
	    
	},
	data(){
		return {
			showFilterData: [],
			showFilterSearch: [],
			// 公众号下拉框-带下滑加载-带搜索
			showFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			gzh_page: 0,
			gzh_limit: 50,
			gzh_fetching: false, // 用于控制提示
			loading_gzh_control: true, // 上拉加载更多控制
			loading_gzh_hint: false, // 上拉加载更多的提示
			// 公众号下拉框-结束
			
			r_gzh_id: undefined,
		}
    },
	computed: {
	},
	mounted(){
		// console.log("子组件生命周期-----")
	},
    methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		getSelectData(d_data){
			let that = this
			let data = d_data || []
			that.showFilterData = data.slice(that.gzh_page, that.gzh_limit)
			that.showFilterSearch = data
			that.showFilterBlur = data
		},
		// 公众号
		handleChangeGzh(value) {
			this.r_gzh_id = value
			this.$emit('handleChangeSelect', value)
		    // console.log(`selected ${value}`);
		},
		
		// 公众号下拉框开始
		popupScrollGzh(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_gzh_control){ // 节流，保证这期间只执行一次
					let that = this
					console.log("上拉触底加载更多gzh_page",that.gzh_page);
					let data
					if(that.showFilterData.length < that.showFilterSearch.length){ // 还有剩余内容时，再加载剩下的内容
						// console.log("that.showFilterData",that.showFilterData.length)
						// console.log("that.showFilterSearch",that.showFilterSearch.length)
						that.loading_gzh_hint = true
						that.loading_gzh_control = false
						
						// slice(开始索引,结束索引) 不改变原数组
						that.gzh_page = that.gzh_page + that.gzh_limit
						data = that.showFilterSearch.slice(that.gzh_page, that.gzh_page + that.gzh_limit)
						that.showFilterData = that.showFilterData.concat(data)
						
						that.loading_gzh_hint = false
						that.gzh_fetching = false
						that.loading_gzh_control = true
					}
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectGzhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.showFilterData = []
			that.gzh_fetching = true
			that.gzh_page = 0
			let f_data = []
			if(e){ // 有搜索字段
				that.showFilterBlur.forEach(res=>{
					if(res.value.indexOf(e) > -1){
						f_data.push(res)
					}
				})
				
				that.showFilterSearch = f_data // 保存一份搜索后的数据
				if(f_data.length > that.gzh_limit){
					that.showFilterData = f_data.slice(that.gzh_page, that.gzh_limit)
				}
				else {
					that.showFilterData = f_data
				}
			}
			else { // 没有搜索字段的话，要避免全部返回
				f_data = that.showFilterBlur.slice(that.gzh_page, that.gzh_limit)
				that.showFilterData = f_data
				that.showFilterSearch = that.showFilterBlur
			}
			
			that.gzh_fetching = false
		},
		// 失去焦点
		gzhBlur(e){
			let that = this
			console.log("失去焦点",e);
			// 都恢复默认值
			that.gzh_page = 0
			that.showFilterData = that.showFilterBlur.slice(that.gzh_page, that.gzh_limit)
			that.showFilterSearch = that.showFilterBlur
		},
		// 公众号下拉框结束

    }
}
</script>

<style scoped>
.page-true {
	width: 100%;
}
.page-false {
	min-width: 200px;
	max-width: 600px;
}
</style>